import { render, staticRenderFns } from "./BlockContent.vue?vue&type=template&id=1fc3fc22&scoped=true"
import script from "./BlockContent.vue?vue&type=script&lang=js"
export * from "./BlockContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3fc22",
  null
  
)

export default component.exports